export default __webpack_public_path__ + "static/media/market-icon.fc772aa9.svg";